import * as S from './PageQrCode.styled'
import QRCode from 'react-qr-code'
import { useRecoilValue } from 'recoil'
import { caseAtom, objectKeySelector } from 'atoms'
import Flex from 'components/priority/Flex/Flex'

export const PageQrCode = ({ itemRef, ...props }) => {
  const qrCodeUrl =
    useRecoilValue(
      objectKeySelector({ atom: caseAtom, property: 'website_obit_url' }),
    ) || ''

  return (
    <S.Shape ref={itemRef} {...props}>
      {qrCodeUrl ? (
        <QRCode
          size={256}
          style={{ height: '100%', width: '100%' }}
          value={qrCodeUrl || ''}
          viewBox={`0 0 256 256`}
        />
      ) : (
        <Flex height="100%" width="100%" background="lockedWhite" center>
          No QR Code added
        </Flex>
      )}
    </S.Shape>
  )
}

export default PageQrCode
